// extracted by mini-css-extract-plugin
export default {"welcomePage":"WelcomePage_welcomePage__gKaJ1"};